// Newest request wins; a superseded one resolves null, which callers must ignore.
const inFlight = new WeakMap();

export default async function loadMembers(input, pageNumber, scope) {
  if (!input) {
    return [];
  }

  inFlight.get(input)?.abort();
  const request = new AbortController();
  inFlight.set(input, request);

  const params = new URLSearchParams({ page: pageNumber });
  const listId = input.dataset.list;
  const search = input.value || "";
  if (listId) {
    params.set("list_id", listId);
  }
  if (search.length) {
    params.set("search", search);
  }
  if (scope) {
    params.set("scope", scope);
  }

  try {
    const response = await fetch(`${input.dataset.membersPath}?${params}`, {
      headers: { Accept: "application/json" },
      signal: request.signal,
    });
    // Best-effort background loader: a non-OK response (e.g. 404 for a list
    // deleted mid-navigation) yields no members rather than crashing the page.
    return response.ok ? await response.json() : [];
  } catch (error) {
    if (error.name === "AbortError") {
      return null;
    }
    throw error;
  } finally {
    if (inFlight.get(input) === request) {
      inFlight.delete(input);
    }
  }
}
